import { showAlert } from "@sazka/design-system/src/modal-alert/mount-alert";
import { RegistrationAnalytics } from "./analytics-registration";

export enum RegistrationEcode {
    RegistrationFailed = 5001,
    RestoreSessionFailed,
    LoadBankListFailed,
    LoadBankListCheckFailed,
    BankIdDataFailed,
    BankIdDataIncomplete,
    BankIdCheckFailed,
    BankIdCheckIncomplete,
    SendGameLimitsFailed,
    SendPersonalDataFailed,
    LastStepVerificationFailed,
    InvokeBankIdFailed,
    GetPlayerDetailFailed,
    ValidationApiFailed,
    QrCodeGenerationFailed,
    BirthdayMismatched,
    OcrVerifyFailed,
    OcrGenericError,
    SetConsentFailed,
    BankIdDeniedByUser,
    SaveBankAccountFailed,
}
interface ErrorText {
    title: string;
    text: string;
}

const genericRetryText = "Zkontrolujte své internetové připojení a proveďte akce znovu.";

const errorDict: Record<RegistrationEcode, ErrorText> = {
    [RegistrationEcode.RegistrationFailed]: {
        title: "Vytvoření účtu se nezdařilo",
        text: genericRetryText,
    },
    [RegistrationEcode.RestoreSessionFailed]: {
        title: "Přihlášení se nezdařilo",
        text: "Vytvoření účtu proběhlo v pořádku, ale nepodařilo se nám vás přihlásit. Zkuste prosím obnovit stránku a přihlásit se.",
    },
    [RegistrationEcode.LoadBankListFailed]: {
        title: "Nepodařilo se načíst seznam bank",
        text: "Zkuste to prosím později nebo využijte možnosti vyplnit údaje ručně.",
    },
    [RegistrationEcode.LoadBankListCheckFailed]: {
        title: "Nepodařilo se načíst seznam bank.",
        text: "Zkuste to prosím později nebo využijte možnosti ověřit údaje osobně.",
    },
    [RegistrationEcode.BankIdDataFailed]: {
        title: "Nepodařilo se získat údaje pomocí BankID",
        text: "Zkuste to prosím později nebo využijte možnosti vyplnit údaje ručně.",
    },
    [RegistrationEcode.InvokeBankIdFailed]: {
        title: "Nepodařilo se navázat spojení s bankou",
        text: genericRetryText,
    },
    [RegistrationEcode.BankIdCheckFailed]: {
        title: "Nepodařilo se ověřit data pomocí BankID",
        text: "Zkuste to prosím později nebo využijte možnosti ověřit údaje osobně.",
    },
    [RegistrationEcode.SendGameLimitsFailed]: {
        title: "Uložení dat se nezdařilo",
        text: genericRetryText,
    },
    [RegistrationEcode.SendPersonalDataFailed]: {
        title: "Uložení dat se nezdařilo",
        text: genericRetryText,
    },
    [RegistrationEcode.LastStepVerificationFailed]: {
        title: "Dokončení registrace se nezdařilo",
        text: genericRetryText,
    },
    [RegistrationEcode.GetPlayerDetailFailed]: {
        title: "Nepodařilo se načíst data o vašem hřáčském účtu",
        text: genericRetryText,
    },
    [RegistrationEcode.BankIdDataIncomplete]: {
        title: "Vaše banka nám neposkytla všechny potřebné údaje",
        text: "Využijte možnosti vyplnit údaje ručně.",
    },
    [RegistrationEcode.BankIdCheckIncomplete]: {
        title: "Vaše banka nám neposkytla všechny potřebné údaje",
        text: "Využijte možnosti ověřit údaje osobně.",
    },
    [RegistrationEcode.ValidationApiFailed]: {
        title: "Nastal problém při ověřování údajů",
        text: genericRetryText,
    },
    [RegistrationEcode.QrCodeGenerationFailed]: {
        title: "Nepodařilo se vygenerovat QR kód pro ověření údajů",
        text: genericRetryText,
    },
    [RegistrationEcode.BirthdayMismatched]: {
        title: "Vaše data nelze uložit",
        text: "Rodné číslo a datum narození se neshodují. Zkontrolujte zadané údaje a zkuste to znovu.",
    },
    [RegistrationEcode.OcrVerifyFailed]: {
        title: "Vaše údaje se nepodařilo ověřit",
        text: genericRetryText,
    },
    [RegistrationEcode.OcrGenericError]: {
        title: "Něco se pokazilo",
        text: genericRetryText,
    },
    [RegistrationEcode.SetConsentFailed]: {
        title: "Nepodařilo se uložit souhlas",
        text: genericRetryText,
    },
    [RegistrationEcode.BankIdDeniedByUser]: {
        title: "Údaje z Bankovní identity nebyly poskytnuty",
        text: "Vyberte jinou metodu zadání údajů.",
    },
    [RegistrationEcode.SaveBankAccountFailed]: {
        title: "Uložení účtu se nezdařilo",
        text: genericRetryText,
    },
};

export const showRegistrationError = (errorCode: RegistrationEcode, withAnalytics = true) => {
    const error = errorDict[errorCode];

    showAlert({
        title: error.title,
        subText: error.text,
        btnCloseText: "OK",
        errorCode: errorCode,
    });

    if (withAnalytics) {
        RegistrationAnalytics.pushError(error.title);
    }
};

export const getRegistrationErrorTitle = (errorCode: RegistrationEcode) => {
    const error = errorDict[errorCode];
    return error.title;
};
